import React from "react";
import { Modal } from "antd";
import Scrollbars from "react-custom-scrollbars-2";

const LessThanOnePercentModal = ({ open, values, onClose, onClickValue, title }) => {
    return (
        <Modal
            title={`Select Value for Less Than ${title ? title : "1%"}`}
            open={open}
            onCancel={onClose}
            footer={null}
        >
            <Scrollbars
                style={{
                    maxWidth: "100%",
                    height: "100%",
                    minHeight: "500px",
                }}
            >
            <ul>
                {values
                    .filter((item) => item.value !== 0)
                    .map((item) => (
                        <li key={item.name}>
                            <div
                                onClick={() => onClickValue(item)}
                                className={"overall-sentiment-concept"}
                            >
                                {item.name}: {(item.value * 100).toFixed(2)}%
                            </div>
                        </li>
                    ))}
            </ul>
            </Scrollbars>
        </Modal>
    );
};

export default LessThanOnePercentModal;
